import { render } from "./PerformanceTable.vue?vue&type=template&id=e468c08c&scoped=true"
import script from "./PerformanceTable.vue?vue&type=script&lang=js"
export * from "./PerformanceTable.vue?vue&type=script&lang=js"

import "./PerformanceTable.vue?vue&type=style&index=0&id=e468c08c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e468c08c"]])

export default __exports__